import { DistributedBars } from '../../Common/Charts/DistributedBars';
import { useProceduresChartsDataContext } from './hooks/useProceduresChartsDataContext';
import { coresMescladasArray } from '../../Common/styles/colors';

export const ProceduresUtiDistribution = () => {
    const { chartData } = useProceduresChartsDataContext();

    const distUti = chartData?.utiDistribution || {};
    const subtitles = Object.keys(distUti).sort((a, b) => {
        const startOf = (label) => parseInt(label.match(/\d+/)?.[0] ?? '0', 10);
        return startOf(a) - startOf(b);
    });
    const values = subtitles.map((bucket) => distUti[bucket]);
    const colors = subtitles.map((_, index) => coresMescladasArray[index % coresMescladasArray.length]);

    return (
        <DistributedBars
            title={'Distribuição dos Dias de UTI Intermediária'}
            values={values}
            subtitles={subtitles}
            colors={colors}
        />
    );
};
